import { Component, OnInit, AfterViewChecked, Input, EventEmitter, Output } from '@angular/core';
import { FlashMessagesService } from "angular2-flash-messages";
import { CommonService } from "../../_services/common.service";
import { environment } from '../../../environments/environment';

declare let paypal: any;
@Component({
  selector: 'app-pay-pal-payment',
  templateUrl: './pay-pal-payment.component.html',
  styleUrls: ['./pay-pal-payment.component.css']
})
export class PayPalPaymentComponent implements AfterViewChecked {
  @Input() orderId: any;
  @Input() finalAmount: number;
  @Input() cardProcessingFee: number = 0;
  @Input() paymentType: string;
  @Input() payPalApiKey: string;
  @Input() addressId: string;
  @Input() isPublicUrl:string;
  @Input() userId:string;
  @Input() isConnectQBO:boolean;
  @Input() shopId:string;
  public paymentOptions: any = {};
  @Output() closePopup = new EventEmitter<boolean>();
  addScript: boolean = false;
  paypalLoad: boolean = true;
  loading: boolean = false;

  constructor(private _flashMessagesService: FlashMessagesService,
    private CommonService: CommonService
  ) {
  }

  paypalConfig = {
    env: environment.PAYPAL_ENV_MODE,
    client: {
      sandbox: '',
      production: ''
    },
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            {
              invoice_number: this.orderId + '-' + new Date().getTime(),
              description: 'Payment for Garment Print order',
              amount: { total: this.finalAmount, currency: 'USD' }
            }
          ]
        }
      });
    },
    onAuthorize: (data, actions) => {
      return actions.payment.execute().then((payment) => {
        //Do something when payment is successful.
        // console.log('payment data', payment);
        // console.log('payment type',this.paymentType);
        this.loading = true;
        if (payment.state == "approved" && payment.payer.status == "VERIFIED") {
          // this._flashMessagesService.show("Payment process completed", {
          //   cssClass: "alert-success",
          //   timeout: 2000
          // });
          this.processPayments(payment.transactions[0].related_resources[0].sale.id);

        }
        else {
          this.loading = false;
          this._flashMessagesService.show("Payment process not completed", {
            cssClass: "alert-danger",
            timeout: 2000
          });
        }

      })
    },
    onCancel: function (data, actions) {
      // Show a cancel page or return to cart


    },
    onError: function (err) {
      // Show an error page here, when an error occurs      

    }

  };

  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        if (this.paypalConfig.env == "production") {
          this.paypalConfig.client.production = this.payPalApiKey;
        }
        else {
          this.paypalConfig.client.sandbox = this.payPalApiKey;
        }
        paypal.Button.render(this.paypalConfig, '#paypal-checkout-btn');
        this.paypalLoad = false;
      })
    }
  }

  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      let scripttagElement = document.createElement('script');
      scripttagElement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    })
  }

  processPayments = function (transactionId) {
    this.paymentOptions = {
     // id: localStorage.getItem("userID"),
      order_id: this.orderId,
      payment_type: this.paymentType,
      amount: this.finalAmount,
      transaction_id: transactionId,
      address_id: this.addressId?this.addressId:'',
      cardProcessingFee: this.cardProcessingFee ? this.cardProcessingFee : 0
    }
    if (this.isPublicUrl == 'Yes') {
      this.paymentOptions.id= this.userId;
      this.paymentOptions.is_public_url= this.isPublicUrl;
    }
    else {
      this.paymentOptions.id= localStorage.getItem("userID");
    }
    this.CommonService.apiService(
      "POST",
      "payment",
      this.paymentOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {

          if (this.isConnectQBO) {
            this.syncInvoicePayment(this.orderId, this.finalAmount, this.paymentType);
          }

          this.closePopup.emit(true);
        } else {
          this.loading = false;
        }
        window.scrollTo(0, 0);

      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 2000
        });

      }
    );
  };

  syncInvoicePayment = function (invoice_id, amount, paymentMethod) {
    this.options = {
      id: this.shopId,
      invoice_id: invoice_id,
      amount: Number(amount),
      paymentMethod: paymentMethod
    };

    this.CommonService.apiService(
      "POST",
      "qbo/syncInvoicePayment",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/pay-pal-payment/pay-pal-payment.component.ts